"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prediction_model_results_viz_1 = require("@tableau/prediction-model-results-viz");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var RootReducer_1 = require("../../../app/RootReducer");
var styles = require("../../../styles/ModelResultStyles");
var NumberUtils_1 = require("../../../util/NumberUtils");
var TestIds_1 = require("../../../util/TestIds");
var Index_1 = require("../../base/Index");
var ModelMetrics_1 = require("../type/ModelMetrics");
var INFO_WIDTH = 350;
var ModelResultStatisticInfo = function () {
    var _a = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), modelType = _a.type, modelMetrics = _a.modelMetrics;
    if (!modelMetrics || !modelType) {
        return React.createElement(Index_1.Error, { message: Localize_1.Messages.chartErrorMessage(), testId: TestIds_1.MODEL_RESULT_CHART_ERROR_TEST_ID + 'additional-metrics' });
    }
    var modelValidation = modelMetrics.validation;
    var informationItems = [
        {
            title: ModelMetrics_1.RegressionMetricsType.MAE,
            value: modelValidation.mae,
            tooltip: Localize_1.Messages.modelResultsCrossValidationInfoMAE(),
        },
        {
            title: ModelMetrics_1.RegressionMetricsType.MSE,
            value: modelValidation.mse,
            tooltip: Localize_1.Messages.modelResultsCrossValidationInfoMSE(),
        },
        {
            title: ModelMetrics_1.RegressionMetricsType.RMSLE,
            value: modelValidation.rmsle,
            tooltip: Localize_1.Messages.modelResultsCrossValidationInfoRMSLE(),
        },
        {
            title: ModelMetrics_1.RegressionMetricsType.RMSE,
            value: modelValidation.rmse,
            tooltip: Localize_1.Messages.modelResultsCrossValidationInfoRMSE(),
        },
    ];
    return (React.createElement("div", { className: styles.RegressionPerformanceMetricsRow }, informationItems.map(function (item, index) {
        return (React.createElement("div", { key: "".concat(item.title, "_").concat(index) },
            React.createElement(prediction_model_results_viz_1.InfoCardComponent, { title: item.title, value: React.createElement(React.Fragment, null, (0, NumberUtils_1.formatNumericField)({ value: item.value })), tooltip: item.tooltip, width: INFO_WIDTH })));
    })));
};
exports.default = ModelResultStatisticInfo;
//# sourceMappingURL=ModelResultStatisticInfo.js.map